(() => {
  const initialise = root => {
    if (!root || root.dataset.storyReady) return;
    root.dataset.storyReady = 'true';
    root.querySelectorAll('.pw-story-nav a').forEach(link => link.addEventListener('click', event => {
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault(); event.stopPropagation();
      target.scrollIntoView({behavior: 'auto', block: 'start'});
    }));
    root.querySelectorAll('[data-story-film]').forEach(wrap => {
      const video = wrap.querySelector('video');
      const button = wrap.querySelector('button');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let loaded = false;
      let userPaused = reduced.matches;
      const load = () => { if (loaded) return; loaded = true; video.querySelectorAll('[data-src]').forEach(s => { s.src = s.dataset.src; }); video.load(); };
      const sync = () => { button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); button.querySelector('span').textContent = video.paused ? '▶' : 'Ⅱ'; };
      const play = () => { load(); video.play().catch(sync); };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      button.addEventListener('click', () => { if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); } });
      new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { load(); if (!userPaused && !document.hidden) play(); } else video.pause(); }), { threshold: 0.25 }).observe(wrap);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
      sync();
    });
  };
  document.querySelectorAll('.pw-story').forEach(initialise);
  document.addEventListener('shopify:section:load', event => initialise(event.target.querySelector('.pw-story')));
})();
